import './style.css';

import { Popover } from '@material-ui/core';
import createReactClass from 'create-react-class';
import _ from 'lodash';
import { observer } from 'mobx-react';
import React from 'react';
import PublishMixin from '../../../mixins/publish-mixin';
import { colours } from '../../../styles/colours';
import { nullOrUndefined } from '../../../utils';
import { OutlineButton } from '../../general/outline-button';
import QuickPick from '../../general/quick-pick/live-mode';
import { ClinicalBaseControl } from '../clinical-base-control';
import Text from '../clinical-text';
import QuickSearch from '../quick-search';
import ReadOnly from '../read-only';

// import Popover from '../../modal/popover';

const ClinicalLookup = observer(
  ClinicalBaseControl(
    createReactClass({
      displayName: 'Lookup',
      mixins: [PublishMixin],

      getInitialState() {
        this.lookupRef = (element) => {
          this.lookup = element;
        };

        return { open: false };
      },

      getDefaultProps() {
        return {
          mode: 'single',
          src: [],

          lookups: {},
          searches: {},
          term: '',
          onSelectNext() {}
        };
      },

      onClick(e) {
        return this.show(e);
      },

      show(e) {
        e.preventDefault();
        const t = e.currentTarget;
        const open = () => {
          this.setState({ open: true }, () => {
            this.scrollIntoView();
          });
        };
        return setTimeout(open, 100);
      }, //this is needed for click integration, can't work out why... :(

      scrollIntoView(override) {
        const { lookup } = this;
        if (!lookup) {
          return;
        }

        const options = override != null ? override : ClinicalLookup.scrollIntoViewOptions;
        lookup.scrollIntoView(options);
      },

      hide() {
        return this.setState({ open: false });
      },

      onTabKeyDown(e) {
        if (e.keyCode === 9) {
          return this.hide();
        }
      },

      onSelect(item) {
        this.setState({ open: false });
        return this.props.onChange(item.value);
      },

      getList() {
        let list = this.props.lists ? this.props.lists[this.props.src] : null;
        if (list) return list;
        try {
          return this.props.lists[this.props.lists._idToNameMap[this.props.src]];
        } catch (ex) {
          // this was a sneaky retro fit, so put in a catch all
          // to make sure existing behaviour was adhered to...
        }
      },

      onChange(val, key) {
        if (this.props['full-lookup-path'] && !this.props.multi) {
          const menu = this.getList();
          let str = key;
          let value = '';
          let prefixIndex = 0;
          if (str.indexOf('main.') > -1) {
            while (prefixIndex > -1 && str !== 'main') {
              prefixIndex = _.lastIndexOf(str, '.');
              const prefix = str.substring(0, prefixIndex);
              let item = menu[prefix][str];
              item = typeof item === 'object' ? item.description : item;
              value = item + (value !== '' ? ` > ${value}` : '');
              str = prefix;
            }
            val = value;
          } else {
            val = str;
          }
        }
        this.setState({ term: val });
        if (this.props.multi) {
          return this.props.onChange(JSON.stringify(val), key);
        } else {
          if (typeof val === 'object') {
            val = JSON.stringify(val);
          }
          this.props.onChange(val, key);
          if (this.props.mode === 'single') {
            this.hide();
            return this.props.onSelectNext();
          }
        }
      },

      onAction(action, args) {
        return typeof this.props.onAction === 'function'
          ? this.props.onAction(action, args)
          : undefined;
      },

      getDisplayPath(key) {
        const { src } = this.props;
        const menu = this.getList();
        if (menu == null) {
          return (__guard__(
            this.props.lookups[src] ||
              _.find(this.props.lookups, (x) => x[this.props.lookupValueMember || 'name'] === src),
            (x) => x.values
          ) || [])[key];
        }

        let str = key;
        let value = '';
        let prefixIndex = 0;
        while (prefixIndex > -1 && str !== 'main') {
          prefixIndex = _.lastIndexOf(str, '.');
          const prefix = str.substring(0, prefixIndex);

          let item = (menu[prefix] != null ? menu[prefix][str] : undefined) || '';
          item = typeof item === 'object' ? item.description : item;
          value = item + (value !== '' ? ` > ${value}` : '');

          str = prefix;
        }
        return value;
      },

      getDisplayComponent(obj) {
        const mapping = Object.keys(obj).map((x) => {
          let val = obj[x];
          val = typeof val === 'string' ? val : val.description;

          if (!this.props['full-lookup-path']) {
            return val;
          }
          return this.getDisplayPath(x) || val;
        });

        if (this.props.inline) {
          return mapping.join(',');
        }
        return (
          <ul>
            {mapping.map((x, i) => (
              <li key={i}>{x}</li>
            ))}
          </ul>
        );
      },

      render() {
        let additional, display, displayText, label, multiSelectValue, other, otherTextExplanation;
        let value = this.get();
        let src = this.props.src || [];

        const { lists, cache, searches } = this.props;

        if (_.isString(src)) {
          var list = this.getList();
          if (list != null) {
            src = list;
          } else {
            src =
              __guard__(
                this.props.lookups[src] ||
                  _.find(
                    this.props.lookups,
                    (x) => x[this.props.lookupValueMember || 'name'] === src
                  ),
                (x) => x.values
              ) || [];
            const listSrc = {};
            src.map((x) => (listSrc[x] = x));
            src = { main: listSrc };
          }
        } else if (_.isString(src[0])) {
          const temp = [];
          src.map((item) => (temp[item] = item));
          src = temp;
        }

        const displayName = this.props.displayName || this.props.buttontext || 'text';

        if (value != null) {
          value = !_.isArray(value) ? [value] : value;
          if (src.length > 0 && _.isObject(src[0]) && !_.isDate(src[0])) {
            value = value.map((x) => {
              return __guard__(
                _.find(
                  src,
                  (s) =>
                    (s.value != null ? s.value.toString() : undefined) ||
                    s.text.toString() === x.toString()
                ),
                (x1) => x1[displayName]
              );
            });
          }

          value = value.join(this.props.seperator);
        }

        if (!this.props.inline && !this.props.hideLabel) {
          label = (
            <span
              style={{
                color: colours.lightBlue,
                fontSize: 16,
                display: 'block'
              }}
              onClick={this.onClick}
            >
              {this.props.label}
            </span>
          );
        }

        if (this.props.readOnly) {
          const otherDisplay =
            this.props.other === 'Allowed with Explanation' &&
            (value || '').toLowerCase().indexOf('other') !== -1 &&
            this.props.valueOther;

          display =
            !!searches[this.props.src] && !!cache[this.props.src]
              ? cache[this.props.src][value]
              : value;
          if (this.props.multi) {
            if ((display || '').indexOf('{') === 0) {
              display = JSON.parse(display) || {};
              display = this.getDisplayComponent(display);
            }
          } else {
            if ((display || '').indexOf('{') === 0) {
              display = JSON.parse(display) || {};
              display = display.description;
            }
          }

          return (
            <span>
              {label}
              <ReadOnly value={display} />
              {!!otherDisplay && (
                <>
                  (<ReadOnly value={otherDisplay} />)
                </>
              )}
            </span>
          );
        }

        const style = this.props.style || {};
        const labelStyle = { fontWeight: 'normal' };

        //if single select value = "other" & multi-select value will be a JSON String
        if (
          this.props.other === 'Allowed with Explanation' &&
          (value || '').toLowerCase().indexOf('other') !== -1
        ) {
          otherTextExplanation = (
            <div
              className="yes-no-details"
              style={{ display: this.props.inline ? 'inline-block' : 'block' }}
            >
              <Text
                value={this.props.valueOther}
                onChange={this.props.onChangeOther}
                label="Details"
                hintText="Please explain the 'Other' answer."
                inline={this.props.inline}
                required={true}
              />
            </div>
          );
        }

        if (this.props.other === 'Allowed with Explanation' || this.props.other === 'Allowed') {
          other = true;
        }

        if (this.props.errored) {
          style.background = colours.red200;
          style.borderColor = colours.red500;
          style.color = colours.red500;
        } else if (this.props.warning && !value) {
          style.background = colours.orange100;
          style.borderColor = colours.orange300;
          style.color = colours.orange300;
        }

        if (
          _.isArray(this.props.src) ||
          _.isObject(this.props.src) ||
          searches[this.props.src] == null
        ) {
          const autoSelect =
            (this.props.src != null
              ? this.props.src.toString().toUpperCase().indexOf('OSICS')
              : undefined) > -1;
          let currentValue = this.props.value;

          if (this.props.multi) {
            displayText = 'Change';
            if ((currentValue || '').indexOf('{') === 0) {
              currentValue = JSON.parse(currentValue) || {};
              multiSelectValue = this.getDisplayComponent(currentValue);
            } else if (currentValue) {
              multiSelectValue = <span className="m-r-5">{currentValue}</span>;
              currentValue = { previousStringSelection: currentValue };
            } else {
              currentValue = {};
              multiSelectValue = null;
            }
          } else {
            if ((currentValue || '').indexOf('{') === 0) {
              currentValue = JSON.parse(currentValue) || {};
              displayText = currentValue.description;
            }
          }

          additional = (
            <QuickPick
              menu={src}
              other={other}
              closeButton={true}
              appendMulti={false}
              multiSelect={this.props.multi}
              open={this.state.open}
              onChange={this.onChange}
              onRequestClose={this.hide}
              autoSelectWhenLast={autoSelect}
              value={currentValue}
              title={this.props.placeholder || 'Select an option'}
            />
          );
        } else {
          value = cache[this.props.src][value] || value;

          additional = (
            <QuickSearch
              open={this.state.open}
              src={this.props.src}
              title={this.props.src}
              onSelect={this.onSelect}
              onAction={this.onAction}
              onRequestClose={this.hide}
            />
          );
        }

        return (
          <div
            ref={this.lookupRef}
            className="bz-clinical-lookup"
            style={{ display: 'inline-block' }}
          >
            {label}
            {multiSelectValue}
            <OutlineButton
              onFocus={this.show}
              style={style}
              onKeyDown={this.onTabKeyDown}
              onClick={this.show}
              classes={{ root: 'clinical-lookup-btn' }}
            >
              {displayText || value || this.props.placeholder || 'Click here to select'}
            </OutlineButton>
            {additional}
            {otherTextExplanation}
          </div>
        );
      }
    })
  )
);

ClinicalLookup.scrollIntoViewOptions = {
  behavior: 'smooth',
  block: 'start',
  inline: 'start'
};

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}

export default ClinicalLookup;
